import React from "react";

const LABEL_CLASS =
  "block text-[10px] font-semibold uppercase tracking-[0.4px] text-ui-text-muted mb-1.5";

const CONTROL_CLASS =
  "w-full rounded-md border border-ui-border bg-ui-surface px-[11px] py-[7px] text-xs text-ui-text outline-none transition-colors placeholder:text-ui-text-subtle focus:border-brand disabled:cursor-not-allowed disabled:opacity-60";

/** Text / number / textarea field styled from theme tokens. */
export default function TextInput({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  required = false,
  disabled = false,
  multiline = false,
  rows = 3,
  prefix,
  suffix,
  inputProps = {},
  className = "",
}) {
  const control = multiline ? (
    <textarea
      name={name}
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder ?? label}
      required={required}
      disabled={disabled}
      rows={rows}
      className={`${CONTROL_CLASS} resize-y`}
      {...inputProps}
    />
  ) : (
    <input
      type={type}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder ?? label}
      required={required}
      disabled={disabled}
      className={`${CONTROL_CLASS} ${prefix ? "pl-7" : ""} ${suffix ? "pr-8" : ""}`}
      {...inputProps}
    />
  );

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={name} className={LABEL_CLASS}>
          {label}
          {required && <span className="ml-0.5 text-state-danger">*</span>}
        </label>
      )}

      {prefix || suffix ? (
        <div className="relative">
          {prefix && (
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-ui-text-subtle">
              {prefix}
            </span>
          )}
          {control}
          {suffix && (
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-ui-text-subtle">
              {suffix}
            </span>
          )}
        </div>
      ) : (
        control
      )}
    </div>
  );
}
